import React from 'react';
import { Field, ErrorMessage, useField } from 'formik';
import './index.css';

const CustomInput = ({ label, name, placeholder, inputClass, checkForCheckoutPage, props }) => {
    const [field, meta, helpers] = useField({ name, ...props });
    return (
        <div className="form-group">
            {label && <label htmlFor={name}>{label}</label>}
            <Field
                type="text"
                name={name}
                placeholder={placeholder}
                readOnly={checkForCheckoutPage}
                className={`custom-input ${inputClass ? "input_required" : ""} ${meta.touched && meta.error ? "is-invalid" : ""}`}
            />
            <ErrorMessage name={name} component="div" className="error-message" />
        </div>
    );
};

export default CustomInput;
